export default class Datenav {
    constructor() {
        this.datenavItems = document.querySelectorAll('.js-datenav-item');
        this.movieLists = document.querySelectorAll('.js-movie-list');
        this.init();
    }

    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.datenavItems.forEach((item) => {
            item.addEventListener('click', (event) => this.handleChange(event));
        });
    }

    handleChange(event) {
        const term = event.currentTarget.getAttribute('data-term');

        this.updateActiveNavItem(event.currentTarget);
        this.updateActiveMovieList(term);
    }

    updateActiveNavItem(activeItem) {
        this.datenavItems.forEach((item) => {
            item.classList.remove('-active');
        });
        activeItem.classList.add('-active');
    }

    updateActiveMovieList(term) {
        this.movieLists.forEach((list) => {
            list.classList.toggle('-active', list.getAttribute('data-term') === term);
        });
    }
}
